module.exports = "img/flags/AO.29ccc70.png";